module.exports = __webpack_public_path__ + "img/development_title.96c954c6.png";